<template>
  <div class="wrapper">
    <div class="page-header page-header-large">
      <parallax
        class="page-header-image"
        style="background-image: url('img/presentation/product_main.png')"
      ></parallax>

      <!-- platform-connected-cars.png -->

      <div class="container" style="padding-top: 250px;">
        <div class="row">
          <div class="col-lg-5 col-md-12 ml-auto mr-auto">
            <h2 class="title">AIR.CAR</h2>
            <!-- <h6 class="category">Technology to combat pollution</h6> -->
            <h5
              class="description"
              style="text-align: left;"
            >NOx emissions lead to Nitrogen Oxide, an irritant that affects lung development in children, responsible for almost 6000 deaths a year in London. AiCAR is researching accurate estimation of connected vehicle’s real-time environmental impact with Imperial College London, partially funded by a £1.4m grant from the UK Government.</h5>
          </div>

          <!-- <div class="col-md-5"> -->
          <div class="col-lg-6 col-md-12"></div>
        </div>
      </div>

      <!-- 
            <div class="about-office">
                <div class="container">
                    <div class="row text-center">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h2 class="title">Our office is our second home</h2>
                            <h4 class="description">Here are some pictures from our office. You can see the place
                                looks like a palace and is fully equiped with everything you need to get the job
                                done.</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg27.jpg">
                        </div>
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg24.jpg">
                        </div>
                        <div class="col-md-4">
                            <img class="rounded img-raised" alt="Raised Image" src="img/bg28.jpg">
                        </div>
                        <div class="col-md-6">
                            <img class="rounded img-raised" alt="Raised Image" src="img/project6.jpg">
                        </div>
                        <div class="col-md-6">
                            <img class="rounded img-raised" alt="Raised Image" src="img/project14.jpg">
                        </div>
                    </div>
                </div>
            </div>
      -->
    </div>

    <div class="about-office" style="padding-bottom: 10px;">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title">What Is Air.Car</h2>
            <h8
              class="description"
            >Using IoT and Smart City technology, AiCAR’s award-winning Air.Car project will deliver the ability to drive a greater understanding of vehicle pollution, while enabling the reduction of environmental impact and vehicle operation costs. Clean Air Zones and London’s Ultra Low Emissions Zones are being developed, and Air.Car’s NOx emissions estimation will give users the information to measure, manage and reduce their impact in real-time, saving fuel and money.</h8>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col-md-12" style="margin: 0px; padding: 0px;">
          <img class="image" alt src="img/air-car/nox-co2-monitoring.jpg" />
        </div>
      </div>
    </div>

    <!-- 
       <div class="section pt-0 pb-0">
          <div class="team-3 section-image" style="background-image: url('img/air-car/nox-co2-monitoring.jpg'); background-color: rgba(0, 0, 0, 0);">
                 <div class="container">
                  <div class="row" style="height: 400px;">
                  </div>
              </div> 
          </div>
       </div>
    -->

    <div
      class="section section-cards"
      style="background-image: url('img/air-car/aircar-partners-bg-e1506954778302.jpg'); background-color: rgba(0, 0, 0, 0); background-size: cover;"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="col-lg-12 col-md-12 ml-auto mr-auto">
              <h2 class="title" style="color: #ffffff;">Working With</h2>
            </div>
          </div>

          <div class="col-md-8">
            <div class="col-md-4" style="display: inline-block; padding: 15px;">
              <img class="rounded img-raised" alt src="img/air-car/IUK.png" />
            </div>
            <div class="col-md-4" style="display: inline-block; padding: 15px;">
              <img class="rounded img-raised" alt src="img/air-car/ICL.png" />
            </div>
            <div class="col-md-4" style="display: inline-block; padding: 15px;">
              <img class="rounded img-raised" alt src="img/air-car/CCAV.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="container">
        <div class="section">
          <h3 class="title text-center">Benefits</h3>
          <p>Air.Car can be used to measure the pollution in Clean Air Zones allowing simple, effective and fair charging of individuals on a vehicle-by-vehicle basis, while also encouraging the reduction of pollution in the worst-hit zones. Other benefits include:</p>
          <br />
          <div class="row">
            <div class="col-md-4 ml-auto" style="text-align: center;">
              <card type="blog" plain>
                <img slot="image" class="img" src="img/air-car/fuel-150x150.jpg" />
                <h4 class="card-title">Save Fuel</h4>

                <!-- 
                <h4 class="category text-info">Hardware Agnostic</h4>
                <h4 class="card-title">
                  <a href="#pablo">Hardware Agnostic</a>
                </h4>
                -->

                <p
                  class="card-description"
                  style="text-align: justify;"
                >By showing the user information about their driving and pollution, Air.Car can help change driver behaviour, while suggesting alternative routes to avoid polluted or busy areas.</p>
              </card>
            </div>

            <div class="col-md-4" style="text-align: center;">
              <card type="blog" plain>
                <img slot="image" class="img" src="img/air-car/reduce-emissions-150x150.jpg" />
                <h4 class="card-title">Reduce Emissions</h4>

                <!-- 
                <h4 class="category text-success">Open APIs & SDKs</h4>
                <h4 class="card-title">
                  <a href="#pablo">Open APIs & SDKs</a>
                </h4>
                -->
                <p
                  class="card-description"
                  style="text-align: justify;"
                >Together with our fuel usage analytics Air.Car will give users the information to measure, manage and reduce their environmental impact in real time. Our technology can improve fuel efficiency by more than 15 per cent and NOx emissions can be halved through better driving.</p>
              </card>
            </div>

            <div class="col-md-4" style="text-align: center;">
              <card type="blog" plain>
                <img
                  slot="image"
                  class="img"
                  src="img/air-car/driver-behaviour-improve-150x150.jpg"
                />
                <h4 class="card-title">Driver Behaviour Improved</h4>

                <!-- 
                <h4 class="category text-info">Big Data & Analytics</h4>
                <h4 class="card-title">
                  <a href="#pablo">Big Data & Analytics</a>
                </h4>
                -->

                <p
                  class="card-description"
                  style="text-align: justify;"
                >With Clean Air Zone and Ultra-Low Emission Zone charging being implemented, Air.Car will enable fair charging, increased ability to see the cost of journeys, while also improving driver behaviour through accurate and useful information on journeys.</p>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox
} from "@/components";
import { Select, Option } from "element-ui";

export default {
  name: "about-us",
  bodyClass: "about-us",
  components: {
    Card,
    InfoSection,
    Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      form: {
        firstName: "",
        email: "",
        speciality: ""
      }
    };
  }
};
</script>
<style>
</style>
